<script setup lang="ts">
/**
 * Singapura — AR Verification of Data 문서 패키지. AGM 패키지와 동일한 "문서 페이지" 크롬:
 *   zoom bar + paper-zoom(794px 중앙) + simple-frame(흰 페이지). 단일 문서라 stepper 없음.
 */
import { ref } from 'vue';
import VerificationDataDoc from './VerificationDataDoc.vue';

const ZOOM_MIN = 100, ZOOM_MAX = 175, ZOOM_STEP = 25;
const docZoom = ref(100);
function setZoom(n: number) { docZoom.value = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(n / ZOOM_STEP) * ZOOM_STEP)); }

function gatherLocalState() { return {}; }
function restoreLocalState() { /* 상태는 fill 값에 있음 */ }
defineExpose({ gatherLocalState, restoreLocalState });
</script>

<template>
  <div class="ver-pkg">
    <div class="zoom-bar">
      <div class="doc-zoom">
        <button type="button" class="doc-zoom-btn" :disabled="docZoom <= ZOOM_MIN" @click="setZoom(docZoom - ZOOM_STEP)">A−</button>
        <button type="button" class="doc-zoom-pct" @click="setZoom(100)">{{ docZoom }}%</button>
        <button type="button" class="doc-zoom-btn" :disabled="docZoom >= ZOOM_MAX" @click="setZoom(docZoom + ZOOM_STEP)">A+</button>
      </div>
    </div>

    <div class="paper-zoom" :style="{ zoom: docZoom / 100 }">
      <div class="stage-head"><span class="stage-badge">AR</span><span class="stage-t">Verification of Data</span></div>
      <div class="pkg-doclabel">
        <span class="ic">📋</span><span class="nm">AR-verification of data.docx</span>
        <span class="no">Doc 1 / 1</span>
      </div>
      <div class="simple-frame">
        <VerificationDataDoc />
      </div>
    </div>
  </div>
</template>

<style scoped>
.ver-pkg { color: #111; }
.zoom-bar { display: flex; justify-content: flex-end; width: 794px; max-width: 100%; margin: 0 auto 14px; }
.doc-zoom { display: inline-flex; align-items: center; gap: 2px; background: #f2f4f6; border-radius: 10px; padding: 2px; }
.doc-zoom-btn, .doc-zoom-pct { border: none; background: transparent; cursor: pointer; font-weight: 800; color: #4b5563; border-radius: 8px; height: 32px; }
.doc-zoom-btn { min-width: 36px; font-size: 15px; }
.doc-zoom-btn:disabled { opacity: 0.35; cursor: default; }
.doc-zoom-pct { min-width: 52px; font-size: 12px; color: #3182f6; }
.paper-zoom { width: 794px; max-width: 100%; margin: 0 auto; }
.stage-head { display: flex; align-items: center; gap: 12px; margin: 0 0 16px; padding: 4px 2px 14px; border-bottom: 1px solid #eef1f6; }
.stage-badge { flex: none; background: #1b64da; color: #fff; font-weight: 800; font-size: 12.5px; padding: 5px 12px; border-radius: 999px; }
.stage-t { font-weight: 800; font-size: 15px; color: #1f2d4d; }
.pkg-doclabel { display: flex; align-items: center; gap: 8px; padding: 0 4px 12px; }
.pkg-doclabel .ic { font-size: 14px; }
.pkg-doclabel .nm { font-size: 12.5px; font-weight: 800; color: #42506a; }
.pkg-doclabel .no { margin-left: auto; font-size: 10.5px; font-weight: 800; color: #9aa6bd; white-space: nowrap; }
.simple-frame { width: 100%; background: #fff; border: 1px solid #e2e5ea; box-shadow: 0 4px 20px rgba(20,30,60,0.09); padding: 32px; box-sizing: border-box; overflow: hidden; font-size: 12px; }
</style>
